import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import rootReducer from "../reducers/index";
import rootSaga from "../sagas";
import config from "./../config/config";
import { getUserContext } from "./../reducers/selectors";
import { signOut } from "../actions/auth";

import React from "react";
import ReactDOM from "react-dom";
import { DebugTools, CommonsHelper } from "bx-react-ui";

const WEB_SOCKET_URL = config.get("WEB_SOCKET_URL");
const WEB_SOCKET_PATH = config.get("WEB_SOCKET_PATH");

export default function configureStore(initialState) {
  const sagaMiddleware = createSagaMiddleware();

  const store = createStore(rootReducer, initialState, applyMiddleware(sagaMiddleware));

  // Add fetch interceptor
  registerFetchInterceptor(store);

  sagaMiddleware.run(rootSaga);

  return store;
}

const registerFetchInterceptor = (store) => {
  return CommonsHelper.fetchIntercept({
    response: function (response, request) {
      if (response.status == 401) {
        store.dispatch(signOut());
        return Promise.reject({ unauthorized: true });
      }

      if (response.status == 500) {
        const DEBUG = config.get("DEBUG");

        if (DEBUG) {
          const modalError = document.createElement("div");
          document.body.appendChild(modalError);

          new Promise((resolve) => {
            // catch proxy error 500
            if (response.bodyUsed == false) {
              resolve({
                url: request[0],
                errorText: response.statusText,
                payload: JSON.stringify(request[1].hasOwnProperty("body") ? request[1].body : {}),
              });
            } else {
              // catch api error 500
              response.json().then((r) => {
                resolve(JSON.parse(r));
              });
            }
          }).then((error) => {
            ReactDOM.render(<DebugTools.ModalError error={error} />, modalError);
          });
        }
      }

      return response;
    },

    responseError: function (error) {
      return Promise.reject(error);
    },
  });
};
